import { render, staticRenderFns } from "./GlobalTotalCounts.vue?vue&type=template&id=7ad701fa&"
import script from "./GlobalTotalCounts.vue?vue&type=script&lang=js&"
export * from "./GlobalTotalCounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports